import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/solid/image-fill.svg'
import _imports_1 from '@/assets/icons/solid/video-fill.svg'


const _hoisted_1 = { class: "-mt-10 -mb-4" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "grid grid-cols-3 gap-6" }
const _hoisted_5 = { class: "col-span-3 lg:col-span-1" }
const _hoisted_6 = {
  key: 0,
  class: "w-96 h-75 rounded-md bg-gray-300 animate-pulse"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 2,
  class: "flex justify-center items-center object-cover w-96 h-75 rounded-md bg-gray-300"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "grayed-icon h-10 w-10",
  src: _imports_0,
  alt: "picture icon"
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "col-span-3 lg:col-span-1" }
const _hoisted_12 = {
  key: 0,
  class: "w-96 h-75 rounded-md bg-gray-300 animate-pulse"
}
const _hoisted_13 = {
  key: 1,
  controls: "",
  class: "object-cover w-96 h-75 rounded-md"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 2,
  class: "flex justify-center items-center object-cover w-96 h-75 rounded-md bg-gray-300"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  class: "grayed-icon h-10 w-10",
  src: _imports_1,
  alt: "video icon"
}, null, -1)
const _hoisted_17 = [
  _hoisted_16
]

import { // languages
		useI18n
	} from 'vue-i18n'

	import { // store
		localesStore
	} from '@/store/locales'

	import { // vue
		inject,
		computed,
		ref
	} from 'vue'	

	
	const __default__ = { name: 'MeetingPlaces' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		job: {
			type: Object,
			default: () => {return {}}
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

	const props = __props

	const _localesStore = localesStore()

	const {t} = useI18n()

	const meetingPlaceDetailsBreadcrumb = computed(() => {
		return [
			{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}}, // Jobs & Meetings
			{label: props?.job?.fieldData?.name_bride_groom_display, to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }},
			{label: _localesStore.getLabel('427'), to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }} // Meeting Places
		]
	})

	const selectedPlace = ref({})
	const optionDetailsModal = ref<{open: boolean}>({open: false})
	const mediaLoading = ref(false)
	const fetchS3File: any = inject('fetchS3File')
	const signedUrlPhoto = ref('')
	const signedUrlVideo = ref('')

	async function openModalDetails(row: any) {
		selectedPlace.value = row
		optionDetailsModal.value.open = true
		try {
			mediaLoading.value = true
			signedUrlPhoto.value = await fetchS3File(row['job__PLACES__jobID::s3JSONPicture'])
			signedUrlVideo.value = await fetchS3File(row['job__PLACES__jobID::s3JSONVideo'])
		}
		catch(e) {
			console.error(e)
		}
		finally {
			mediaLoading.value = false
		}
	}
	
	function hasPicture(row: any) {
		return row?.['job__PLACES__jobID::s3JSONPicture']
	}

	function hasVideo(row: any) {
		return row?.['job__PLACES__jobID::s3JSONVideo']
	}

return (_ctx: any,_cache: any) => {
  const _component_tw_table_column = _resolveComponent("tw-table-column")!
  const _component_CheckIconMini = _resolveComponent("CheckIconMini")!
  const _component_MinusIconMini = _resolveComponent("MinusIconMini")!
  const _component_tw_table = _resolveComponent("tw-table")!
  const _component_data_display = _resolveComponent("data-display")!
  const _component_tw_modal = _resolveComponent("tw-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_tw_table, {
      placeholder: _unref(t)('placeholders.noMeetingPlaces'),
      data: props?.job?.portalData?.portal_meeting_places,
      loading: __props.loading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_tw_table_column, {
          header: "",
          prop: "job__PLACES__jobID::description_display"
        }),
        _createVNode(_component_tw_table_column, {
          header: _unref(_localesStore).getLabel('411')
        }, {
          default: _withCtx(({row}) => [
            (row['job__PLACES__jobID::primary'])
              ? (_openBlock(), _createBlock(_component_CheckIconMini, {
                  key: 0,
                  class: "h-5 w-5 text-black"
                }))
              : (_openBlock(), _createBlock(_component_MinusIconMini, {
                  key: 1,
                  class: "h-5 w-5 text-gray-300"
                }))
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_tw_table_column, {
          "class-name": "w-6",
          "header-class-name": "w-6",
          "align-text": "right"
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("div", {
              class: "h-6 w-6 cursor-pointer",
              onClick: ($event: any) => (openModalDetails(row))
            }, [
              _createElementVNode("img", {
                class: _normalizeClass([hasPicture(row) ? 'linked-icon' : 'grayed-icon']),
                src: _imports_0,
                alt: "picture icon"
              }, null, 2)
            ], 8, _hoisted_2)
          ]),
          _: 1
        }),
        _createVNode(_component_tw_table_column, {
          "class-name": "w-6",
          "header-class-name": "w-6",
          "align-text": "right"
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("div", {
              class: "h-6 w-6 cursor-pointer",
              onClick: ($event: any) => (openModalDetails(row))
            }, [
              _createElementVNode("img", {
                class: _normalizeClass([hasVideo(row) ? 'linked-icon' : 'grayed-icon']),
                src: _imports_1,
                alt: "picture icon"
              }, null, 2)
            ], 8, _hoisted_3)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["placeholder", "data", "loading"]),
    _createVNode(_component_tw_modal, {
      title: selectedPlace.value?.['job__PLACES__jobID::description_display'],
      breadcrumb: meetingPlaceDetailsBreadcrumb.value,
      ref_key: "optionDetailsModal",
      ref: optionDetailsModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_data_display, {
              label: _unref(_localesStore).getLabel('293')
            }, {
              custom: _withCtx(() => [
                (mediaLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                  : (signedUrlPhoto.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        class: "object-cover w-96 h-75 rounded-md",
                        src: signedUrlPhoto.value
                      }, null, 8, _hoisted_7))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_data_display, {
              label: _unref(_localesStore).getLabel('294')
            }, {
              custom: _withCtx(() => [
                (mediaLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                  : (signedUrlVideo.value)
                    ? (_openBlock(), _createElementBlock("video", _hoisted_13, [
                        _createElementVNode("source", {
                          type: "video/mp4",
                          src: signedUrlVideo.value
                        }, null, 8, _hoisted_14)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "breadcrumb"])
  ]))
}
}

})